import React, { ChangeEvent } from "react";

interface CheckboxProps {
  id?: string;
  checked: boolean;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  label?: string;
  disabled?: boolean;
}

export const Checkbox: React.FC<CheckboxProps> = ({
  id,
  checked,
  onChange,
  className = "",
  label,
  disabled = false,
}) => {
  return (
    <div className={`flex items-center ${className}`}>
      <input
        id={id}
        type="checkbox"
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500 cursor-pointer"
      />
      {label && (
        <label
          htmlFor={id}
          className="ml-2 block text-sm text-gray-900 cursor-pointer"
        >
          {label}
        </label>
      )}
    </div>
  );
}; 